import React from "react";
import { Phone, CarFront, CheckCircle2, ThumbsUp } from "lucide-react";

const STEPS = [
  {
    icon: Phone,
    num: "1",
    title: "Zavoláte nám",
    text: "Domluvíme se na vašich potřebách a termínu.",
  },
  {
    icon: CarFront,
    num: "2",
    title: "Vše zařídíme za vás",
    text: "Postaráme se o STK, emise, přepisy i další služby.",
  },
  {
    icon: CheckCircle2,
    num: "3",
    title: "Vy řídíte svůj čas",
    text: "Ušetříte čas, nervy i zbytečné čekání.",
  },
  {
    icon: ThumbsUp,
    num: "4",
    title: "Hotovo bez starostí",
    text: "Vše vyřešeno — vy se jen pohodlně vrátíte na cestu.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="jak-to-funguje"
      data-testid="how-it-works-section"
      className="relative bg-[#0A0D17] text-white py-24 lg:py-28 overflow-hidden"
    >
      <div className="absolute inset-0 hero-grid opacity-40" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <span className="text-xs uppercase tracking-[0.22em] text-amber-300 font-semibold">
            Postup
          </span>
          <h2 className="font-heading mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
            Jak to funguje?
          </h2>
          <p className="font-body mt-5 text-lg text-slate-300">
            Čtyři jednoduché kroky od telefonu k vyřízené službě.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 relative">
          {STEPS.map((s, idx) => (
            <div
              key={s.num}
              data-testid={`how-step-${s.num}`}
              className="relative rounded-3xl border border-amber-300/15 bg-white/[0.03] p-7 backdrop-blur-sm transition-all hover:-translate-y-1 hover:border-amber-300/30"
            >
              <div className="flex items-center justify-between">
                <span className="font-heading text-5xl font-extrabold text-amber-300/20">
                  {s.num}
                </span>
                <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-amber-300/10 border border-amber-300/20 text-amber-300">
                  <s.icon className="h-5 w-5" />
                </div>
              </div>
              <div className="font-heading mt-4 text-xl font-bold text-white">
                {s.title}
              </div>
              <p className="mt-2 text-sm text-slate-400 leading-relaxed">{s.text}</p>

              {idx < STEPS.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 h-px w-6 bg-amber-300/30" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
